var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box relative",style:({ overflowX: 'auto' })},[_c('Table',{attrs:{"data":_vm.sortedData || [],"config":_vm.config,"onRowClick":_vm.onRowClick,"sortByKey":_vm.sortByKey,"sortDirection":_vm.sortDirection,"updateSort":_vm.updateSort}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }